import { useCallback } from 'react';
import axios from 'axios';
import { useBadgeNotification } from '../context/BadgeNotificationContext';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Hook to check and award badges after certain actions
 * Usage: const { checkBadges } = useBadgeChecker(childId);
 *        await checkBadges(); // Call after measurement, test, journal, etc.
 */
export function useBadgeChecker(childId) {
  const { showMultipleBadges } = useBadgeNotification();

  const checkBadges = useCallback(async () => {
    if (!childId) return;
    
    try {
      const res = await axios.post(`${API}/badges/check/${childId}`);
      if (res.data.newly_earned?.length > 0) {
        // Show badge notification popups with confetti!
        showMultipleBadges(res.data.newly_earned);
        return res.data.newly_earned;
      }
    } catch (err) {
      console.error('Failed to check badges:', err);
    }
    return [];
  }, [childId, showMultipleBadges]);

  return { checkBadges };
}

export default useBadgeChecker;
